import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { IVariants } from "./types";

const CART_UPSELL_TEST_IDS_PREFIX = "cart-upsell";

export const CART_UPSELL_TEST_IDS = {
    NUDGE: `${CART_UPSELL_TEST_IDS_PREFIX}-nudge`,
    TITLE: `${CART_UPSELL_TEST_IDS_PREFIX}-title`,
    SUBTITLE: `${CART_UPSELL_TEST_IDS_PREFIX}-subtitle`,
    PLAN_INFO_CTA: `${CART_UPSELL_TEST_IDS_PREFIX}-plan-info-cta`,
    ONE_TAP_CTA: `${CART_UPSELL_TEST_IDS_PREFIX}-one-tap-cta`,
    ONE_TAP_CTA_TEXT: `${CART_UPSELL_TEST_IDS_PREFIX}-one-tap-cta-text`,
    BASE_PRICE: `${CART_UPSELL_TEST_IDS_PREFIX}-base-price`,
    FINAL_PRICE: `${CART_UPSELL_TEST_IDS_PREFIX}-final-price`,
    ANIMATED_TITLE: `${CART_UPSELL_TEST_IDS_PREFIX}-animated-title`,
    CHANGE_PLAN_CTA: `${CART_UPSELL_TEST_IDS_PREFIX}-change-plan-cta`,
};

export enum VARIANTS {
    DEFAULT = "DEFAULT",
    V1 = "V1",
    V2 = "V2",
}

export const BR_TAG = "<br>";

export const TITLE_VARIANTS: IVariants = {
    [VARIANTS.DEFAULT]: { variant: "V2.body3.neutral.bold", color: "primary_One_Blck" },
    [VARIANTS.V1]: { variant: "V2.body2.neutral.bold", color: "swiggy_One" },
    [VARIANTS.V2]: { variant: "V2.body2.neutral.bold", color: "text_Highest_Emphasis" },
};

// using line-height value from base theme
export const TITLE_HEIGHT = {
    [VARIANTS.DEFAULT]: 17,
    [VARIANTS.V1]: 18,
    [VARIANTS.V2]: 18,
};

export const SUBTITLE_VARIANTS: IVariants = {
    [VARIANTS.DEFAULT]: { variant: "V2.body3.neutral.regular", color: "text_Low_Emphasis" },
    [VARIANTS.V1]: { variant: "V2.body3.neutral.medium", color: "text_High_Emphasis" },
    [VARIANTS.V2]: { variant: "V2.body3.neutral.medium", color: "text_Med_Emphasis" },
};

export const SINGLE_SPACE_IDENTIFIER = " ";

export const CART_UPSELL_LOGO_CONFIG = {
    LITE: {
        height: "12px",
        width: "53px",
    },
    PLUS: {
        height: "10px",
        width: "29px",
    },
    BLACK: {
        height: "14px",
        width: "14px",
    },
};

export const DEFAULT_GRATIFICATION_DURATION = 5; // in seconds
export const DEFAULT_GRATIFICATION_DURATION_WITH_LOTTIE = 10; // in seconds

export const REMOVE_PLAN_COLOR_TAGS = {
    OPEN: `<span style="color:${BaseTheme.colors[BaseTheme.colorMode].swiggy_One};">`,
    CLOSE: `</span>`,
};

export const REMOVE_BLCK_PLAN_COLOR_TAGS = {
    OPEN: `<span style="color:${BaseTheme.colors[BaseTheme.colorMode].secondary_One_Blck};">`,
    CLOSE: `</span>`,
};

export const REMOVE_PLAN_STRIKED_TAGS = {
    OPEN: `<s style="color:${BaseTheme.colors[BaseTheme.colorMode].text_Low_Emphasis};">`,
    CLOSE: `</s>`,
};

export const TITLE_UNDERLINE_DEFAULT_WIDTH = 100;

export const BLACK_MEMBERSHIP_BACKGROUND_ASSET = "portal/static-assets/images/cart_upsell_background_black.png";
export const BLACK_MEMBERSHIP_BACKGROUND_ALT = "black background image";

export const DELAYS = {
    POLLING_INTERVAL: 800, // in ms
};

export const MAX_POLLING_COUNT = 250; // Maximum polling count to check the planId stored in the appStorage from Comparison halfcard

export const COMPARISON_HALFCARD_STORAGE_KEY = "comarison-halfcard-storage-key";

export const URL_PLACEHOLDER = "url=";
